import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Content from '../../ui/Content'
import Feed from './Feed'
import RichText from '../../ui/RichText'
import Section from '../../ui/Section'

const SocialFeedDefault = ({
  alignment,
  apiParams,
  backgroundImage,
  background,
  classNames,
  copy,
  copyAlignment,
  foreground,
  items = [],
  layout,
  size,
  spacing,
  subtitle,
  title,
  titleForeground
}) => (
  <Section
    alignment={alignment}
    backgroundImage={backgroundImage}
    background={background}
    foreground={foreground}
    size={size}
    spacing={spacing}>

    <Content
      copy={copy}
      copyAlignment={copyAlignment}
      layout={layout}
      subtitle={subtitle}
      title={title}
      titleForeground={titleForeground}>

      <div className={classNames.root}>
        {items.map((feed, index) => (
          <div key={index} className={classNames.section}>
            {feed.title && <RichText>{feed.title}</RichText>}
            <div className={classNames.feed}>
              <Feed network={feed.network} handle={feed.handle} />
            </div>
          </div>
        ))}
      </div>

    </Content>
  </Section>
)

export default withStyles(styles)(SocialFeedDefault)
